import { EntityRequestExpenses } from "../../entity/EntityRequestExpenses";

export class DtoRequestExpensessPutRes extends EntityRequestExpenses {}
